<template>
    <div class="echart" :style="{ width, height }"></div>
</template>
  
<script>
import echartHook from "./hooks/echartHook";

export default {
    props: {
        option: {
            type: Object,
            default: () => ({}),
        },
        width: {
            type: String,
            default: "100%",
        },
        height: {
            type: String,
            default: "100%",
        },
    },
    data() {
        return {
            chart: null,
        }
    },

    mounted() {
        this.initChart();
    },

    watch: {
        option: {
            handler(newVal) {
                this.setOption(newVal);
            },
            deep: true,
        }
    },

    methods: {
        initChart() {
            this.chart = this.$el;
            const { setOption } = echartHook(this.chart);
            setOption(this.option);
        },
        setOption(option) {
            const { setOption } = echartHook(this.chart);
            setOption(option);
        },
    },

};


</script>
  
<style lang="less" scoped>

</style>
  